import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

const ModalTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: var(--color-primary);
  font-size: 1.25rem;
  font-weight: 600;
`;

const ModalMessage = styled.p`
  margin: 0 0 1.5rem 0;
  color: var(--color-secondary-text);
  font-size: 1rem;
  line-height: 1.5;
`;

const CloseButton = styled.button`
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background:var(--color-secondary);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
  }
`;

function NoPropertiesModal({ onClose }) {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <ModalTitle>No Properties Found</ModalTitle>
        <ModalMessage>
          No properties found for the entered criteria. Please try adjusting your search parameters
          or add properties manually.
        </ModalMessage>
        <CloseButton onClick={onClose}>
          OK
        </CloseButton>
      </ModalContent>
    </ModalOverlay>
  );
}

NoPropertiesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default NoPropertiesModal;
